import { apiRequest, } from "../remote/ApiHelper";
import { ApiPaths } from "../remote/ApiPaths";
import { PageModel } from "../models/PageModel";
import { showLog } from "../helper/utility";

export const fetchDynamicService= async (): Promise<{ dynamicServices: PageModel[]; }> => {
  const response = await apiRequest(
    `${ApiPaths.GET_ALL_DYNAMIC_SERVICES()}`,
    "GET", undefined, false, false
  );
if (response.success) {
    return {
      dynamicServices: response.data.records,
    };
  } else {
    showLog("Failed to fetch dynamic service:",response.message);
    return {
      dynamicServices: [],
    };
  }
};

export const fetchDynamicServiceDetail = async (id: string): Promise<{ response: boolean, dynamicServiceDetail: PageModel | null; }> => {
  const response = await apiRequest(`${ApiPaths.GET_DYNAMIC_SERVICE()}/${id}`, "GET");
  if (response.success) {
    return {
      response: true,
      dynamicServiceDetail: response.data.record,
    };
  } else {
    return {
      response: false,
      dynamicServiceDetail: null,
    };
  }
};
